import { FormControl } from 'baseui/form-control'
import { KIND, SIZE } from 'baseui/button'
import SDInput from '@/shared/components/SDComponents/SDInput/SDInput'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { OuterContainer, Block, BlockTitle } from '../styled-components'
import useComparatorAdd from './useComparatorAdd'

const ComparatorAdd = () => {
  const { t, name, error, save, handleNameChange, handleSave, handleCancel, isSelectraAdmin } = useComparatorAdd()

  if (!isSelectraAdmin) {
    return <OuterContainer><Block>{t('comparator.unauthorized')}</Block></OuterContainer>
  }

  return (
    <OuterContainer>
      <Block>
        <BlockTitle>{t('comparator.add_title')}</BlockTitle>
        <FormControl label={t('name')} error={error}>
          <SDInput
            error={error}
            value={name}
            onChange={handleNameChange}
          />
        </FormControl>
        <SDButton
          onClick={handleSave}
          size={SIZE.compact}
          kind={KIND.primary}
          isLoading={save.loading}
        >
          {t('comparator.save_btn')}
        </SDButton>
        <SDButton
          onClick={handleCancel}
          size={SIZE.compact}
          kind={KIND.tertiary}
        >
          {t('common:cancel')}
        </SDButton>
      </Block>
    </OuterContainer>
  )
}

export default ComparatorAdd
